module.exports = __webpack_public_path__ + "/content/shared/img/fusion/landing/Fusion.Config.Resources.BuyerLandingImages.Images9_Honda.png";